// extracted by mini-css-extract-plugin
export var arrows = "_5q-5";
export var decrementer = "_5q-9";
export var disabled = "_5q-3";
export var error = "_5q-1";
export var hiddenText = "_5q-a";
export var incrementer = "_5q-8";
export var input = "_5q-7";
export var inputWrapper = "_5q-0";
export var readonly = "_5q-2";
export var regular = "_5q-6";
export var small = "_5q-4";